<nav #header *ngIf="renderMenu" class=" fixed-top headerStyle"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}"
    style="filter: drop-shadow(1px 1px 1px #6666664d);">
    <div style="background-color: #13172B;" class="contactHeader">
        <div class="green containerHeader">
            <div class="question">
                Have any Questions?:
                <a style="text-decoration: none; padding-right: 20px; color: #FF9933"
                    href="tel:+593989767063" target="_blank">
                    +593 98 976 7063</a>
            </div>
            <div class="address">
                39XW+X3P, Puerto Baquerizo Moreno
            </div>
            <div class="social-networks">
                <a href="https://www.facebook.com/profile.php?id=61583920825742" target="_blank"><i class="fa fa-facebook"></i></a>
                <a href="https://www.tiktok.com/@galaapp.ec?_r=1&_t=ZS-" target="_blank"><i class="fa fa-tiktok"></i></a>
                <a href="https://www.instagram.com/galaapp.ec/" target="_blank"><i class="fa fa-instagram"></i></a>
                <a href="https://www.youtube.com/@GALAAPP-sg1xdENLACES%20" target="_blank"><i class="fa fa-pinterest"></i></a>
                <div>
                    <a href="https://galaapp.net/#" target="_blank"><img src="assets/images/en-us.png"></a>
                    <a href="https://galaapp.net/#" target="_blank"><img src="assets/images/es-co.png"></a>
                </div>
            </div>
        </div>
    </div>
    <div #header1 class="green containerMenu">
        <div *ngIf="companyParamsService.getHasLogoInformation()" class="tooltip fade show bs-tooltip-right"
            role="tooltip" id="tooltip164687" x-placement="right"
            style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(266px, 24px, 0px);">
            <div class="arrow" style="top: 8px;"></div>
            <div class="tooltip-inner">Your Logo Here</div>
        </div>
        <a *ngIf="!this.companyParamsService.getWebSite()" class="navbar-brand" target="_blank" class="navbar-brand"
            data-container=".green" data-toggle="tooltip" data-placement="right" title="Your Logo Here">
            <img src="assets/img/logo.jpg" height="50" alt="logo" class="brand-logo">
        </a>
        <a *ngIf="this.companyParamsService.getWebSite()" href="https://galaapp.net/" class="navbar-brand"
            target="_blank">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().logoFade}}" id="logoFade">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().fadeMenu}}" id="fadeMenu">
            <img src="../assets/images/logos-header/ga.svg" alt="logo" class="brand-logo" style="height: 44px;">
        </a>
        <div class="containerMenu navbar-collapse collapse" style="width: inherit;">
            <ul class="navbar-nav menuContainer" style="width: inherit;">
                <li class="nav-item menuItem"><a href="https://galaapp.net/" target="_blank"><i
                            class="fa fa-home" style="color: #02D399;"></i></a></li>
                <li class="nav-item menuItem"><a href="https://galaapp.net/cruises/" target="_blank">Cruises <i
                            class="fa fa-angle-down"></i></a></li>
                <li class="nav-item menuItem"><a href="https://galaapp.net/tours/" target="_blank">Tours <i
                            class="fa fa-angle-down"></i></a></li>
                <li class="nav-item menuItem"><a href="https://galaapp.net/transportation/"
                        target="_blank">Transportation</a></li>
                <li class="nav-item menuItem"><a href="https://galaapp.net/#" target="_blank">Join Us</a>
                </li>
                <li class="nav-item menuItem"><a href="https://galaapp.net/blog" target="_blank">Blog</a>
                </li>
                <li class="nav-item menuItem"><a href="https://galaapp.net/my-account/" target="_blank">My
                        Account <i class="fa fa-angle-down"></i></a></li>
            </ul>
            <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                <app-heart-header></app-heart-header>
            </div>
        </div>
        <div>
            <a class="last-minute" href="https://galaapp.net/last-minute/" target="_blank">Last Minute<i
                    class="fa fa-long-arrow-right" style="padding-left: 10px;"></i></a>
        </div>
        <div class="container green containerHeader" style="justify-content: end; flex-direction: row!important;"
            class="responsiveHeader">
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()" style="padding-right: 1em;">
                <i class="fa fa-bars fa-2x" style="padding-right: 10px;"></i>
            </a>
        </div>
    </div>
    <ul style="width: inherit; display: none;" class="menuContainer" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem"><a href="https://galaapp.net/cruises/" target="_blank">Cruises <i
                    class="fa fa-angle-down"></i></a></li>
        <li class="nav-item menuItem"><a href="https://galaapp.net/tours/" target="_blank">Tours <i
                    class="fa fa-angle-down"></i></a></li>
        <li class="nav-item menuItem"><a href="https://galaapp.net/transportation/" target="_blank">Transportation</a>
        </li>
        <li class="nav-item menuItem"><a href="https://galaapp.net/#" target="_blank">Join Us</a>
        </li>
        <li class="nav-item menuItem"><a href="https://galaapp.net/blog" target="_blank">Blog</a>
        </li>
        <li class="nav-item menuItem"><a href="https://galaapp.net/my-account/" target="_blank">My
                Account <i class="fa fa-angle-down"></i></a></li>
    </ul>
    <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container"
        [ngClass]="showMenu ? 'showMenu':''" style="width: inherit; display: none;">
        <app-heart-header></app-heart-header>
    </div>
</nav>